<div class="attachment-viewer">
    <ion-button slot="icon-only" class="attachment-viewer-close" (click)="close()"><ion-icon name="close"></ion-icon></ion-button>
</div>
